import { Box, Paper } from "@mui/material";
import FormComponent from "../../components/global/FormComponent";
import { useNavigate } from "react-router-dom";
import Error404 from "../../pages/Error404";
import secureLocalStorage from "react-secure-storage";

const formConfig = [
  {
    field: {
      type: "text",
      title: "Name",
      id: "name",
      name: "name",
      placeholder: "Your Name",
      required: true,
      error: {
        condition: (value) => value.trim() === "",
        message: "Name is required",
      },
    },
  },
  {
    field: {
      type: "text",
      title: "User Name",
      id: "username",
      name: "username",
      placeholder: "Your User Name",
      required: true,
      error: {
        condition: (value) => value.trim() === "",
        message: "User Name is required",
      },
    },
  },
  {
    field: {
      type: "email",
      title: "Email",
      id: "email",
      name: "email",
      placeholder: "Your Email",
      required: true,
      error: {
        condition: (value) => !/^\S+@\S+\.\S+$/.test(value),
        message: "Invalid email format",
      },
    },
  },
  {
    field: {
      type: "password",
      title: "Password",
      id: "password",
      name: "password",
      placeholder: "Your Password",
      required: true,
      error: {
        condition: (value) => value.trim() === "" || value.length < 8,
        message: "Password should be at least 8 characters long",
      },
    },
  },
];

const Profile = ({ role }) => {
  const navigate = useNavigate();
  const userDataString = secureLocalStorage.getItem("userInfo");
  const userData = JSON.parse(userDataString);
  console.log(userData);
  const handleClick = () => {
    navigate("/admin/edit/profile", {
      state: { profileData: userData, formConfig: JSON.stringify(formConfig) },
    });
  };
  return (
    <>
      {role === "admin" ? (
        <Box m={"2vw"}>
          <Paper
            style={{
              background: "#222222ed", //rgb(8 6 17 / 27%)"
              padding: "2vh 2vw",
              width: "75%",
              margin: "auto",
            }}
          >
            <FormComponent
              formTitle="View Profile Information"
              formConfig={formConfig}
              buttonText={"Edit Profile"}
              disableEdit={true}
              handleAddOrUpdate={handleClick}
              fieldValue={userData}
            />
          </Paper>
        </Box>
      ) : (
        <Error404 />
      )}
    </>
  );
};

export default Profile;
